module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQuitModal),
      expression: "showQuitModal"
    }],
    staticClass: "pop-quit",
    on: {
      "click": _vm.closeQuitModal
    }
  }, [_c('div', {
    staticClass: "pop-body",
    on: {
      "click": _vm.preventDefault
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.activityImgSrc
    },
    on: {
      "click": _vm.toFreeGet
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d42604a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuitModal.vue
// module id = 26
// module chunks = 4 63 64 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82 91 92 93 94 95 96 97 98 99 100 101 102 103 104 105 106 107 108 109 110 111 112 113 114 115 116 117 118 119 120 121 122 123 124 131 132 133 134 135 136 137 138